import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.js';
// Imported for its side effect: i18next must be initialised before any component
// that calls useTranslation renders.
import './i18n.js';
import { applyStoredConsent } from './lib/analytics.js';
import { applyTheme, getStoredTheme } from './lib/theme.js';
import { initWebAnalytics } from './lib/web-analytics.js';
// Order matters: tokens define the custom properties the other two consume.
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';

// Before the first render, so a light-theme user never sees a dark flash.
applyTheme(getStoredTheme());

// Re-applies a consent choice from a previous visit; does nothing on a first
// visit until CookieConsent.tsx's banner records one. Cloudflare's beacon is
// cookieless and loads regardless — see web-analytics.ts.
applyStoredConsent();
initWebAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
